import { useRef, useEffect, useState, type HTMLAttributes } from "react";

export function ResponsiveTable({ children, ...props }: HTMLAttributes<HTMLDivElement>) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [scrolledEnd, setScrolledEnd] = useState(false);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const check = () => {
      const canScroll = el.scrollWidth > el.clientWidth + 2;
      setIsScrollable(canScroll);
      setScrolledEnd(canScroll && el.scrollLeft + el.clientWidth >= el.scrollWidth - 4);
    };

    check();
    el.addEventListener("scroll", check, { passive: true });
    const ro = new ResizeObserver(check);
    ro.observe(el);

    return () => {
      el.removeEventListener("scroll", check);
      ro.disconnect();
    };
  }, [children]);

  return (
    <div
      className={`table-wrapper${isScrollable ? " is-scrollable" : ""}${scrolledEnd ? " scrolled-end" : ""}`}
      {...props}
    >
      <div ref={scrollRef} className="table-scroll">
        {children}
      </div>
    </div>
  );
}
